module.exports = __webpack_public_path__ + "static/img/rm_brand_img_ousaisi_details.0577708.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rm_brand_img/rm_brand_img_ousaisi_details.png
// module id = UVqm
// module chunks = 1